export default __webpack_public_path__ + "static/media/sidebar-2.00b17713.jpg";